var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:_vm.type,on:{"click":_vm.navigateToLink}},[_vm._t("default"),_vm._v(" "),(_vm.overlayIsActive && _vm.overlayMenuIsActive)?_c('UIOverlay',{staticClass:"menu-overlay",attrs:{"id":"overlay"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }